var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "类型" } },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "radio-group-city",
              model: {
                value: _vm.value.inputType,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "inputType", $$v)
                },
                expression: "value.inputType",
              },
            },
            [
              _c("el-radio", { attrs: { label: "city" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("省市")]),
              ]),
              _c("el-radio", { attrs: { label: "area" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("省市区")]),
              ]),
              _c("el-radio", { attrs: { label: "detail" } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("省市区-街道"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }